module.exports = __webpack_public_path__ + "r-v3/img/sticker_17.5b2f2cc4.svg";